import { buildCreateApi, coreModule, reactHooksModule } from '@reduxjs/toolkit/dist/query/react';

import { normalizeUrl } from '#helper/normalize-url';
import { enhancedBaseQuery } from '#adapter/enhanced-base-query';

import environment from '#environment';

/*
    Если у вас есть необходимость в использование контекста хранилища для createApi.
    Вы это можете сделать здесь по нижеприведенному примеру.

    https://redux-toolkit.js.org/rtk-query/usage/customizing-create-api

    Example:

    import { createDispatchHook, createSelectorHook, createStoreHook } from 'react-redux';

    export const createApi = buildCreateApi(
        coreModule(),
        reactHooksModule({
            useDispatch: createDispatchHook(context),
            useSelector: createSelectorHook(context),
            useStore   : createStoreHook(context)
        })
    );
*/
export const createApi = buildCreateApi(coreModule(), reactHooksModule());

export const separateApiAuth = createApi({
    reducerPath: 'api/auth',
    baseQuery  : enhancedBaseQuery({
        baseUrl        : normalizeUrl(`${environment.hostSellerAuth}/auth`),
        headers        : { 'cache-control': 'no-cache' },
        credentials    : 'include',
        jsonContentType: 'application/json',
        prepareHeaders : (headers) => {
            headers.set('content-type', 'application/json');

            return headers;
        }
    }),
    endpoints: () => ({})
});
export type SeparateAuthBaseApiType = typeof separateApiAuth;
